export class callPopin extends HTMLButtonElement {
    connectedCallback() {
      this.addEventListener('click', () => this.expanded = !this.expanded);
    }
  
    set expanded (value){
      this.setAttribute('aria-expanded', value ? 'true' : 'false');
      this.controlledElement.classList.add('active');
      if (this.getAttribute('aria-overlay') == 'popin-overlay') {
        this.controlledElementOverlay.classList.add('active');
      }
      if (this.getAttribute('aria-scroll') == 'body-scroll') {
        document.querySelector('body').classList.add('no-scroll');
      }
      
    }
  
    get expanded () {
      return this.getAttribute('aria-expanded') === 'true';
    }
  
    get controlledElement() {
      const element = document.getElementById(this.getAttribute('aria-controls'));
      return element;
    }
    get controlledElementOverlay() {
        const element = document.getElementById(this.getAttribute('aria-controls')+'__overlay');
        return element;
    }
}
export class callPopinSpan extends HTMLSpanElement {
  connectedCallback() {
    this.addEventListener('click', () => this.expanded = !this.expanded);
  }

  set expanded (value){
    this.setAttribute('aria-expanded', value ? 'true' : 'false');
    this.controlledElement.classList.add('active');
    if (this.getAttribute('aria-overlay') == 'popin-overlay') {
      this.controlledElementOverlay.classList.add('active');
    }
    if (this.getAttribute('aria-scroll') == 'body-scroll') {
      document.querySelector('body').classList.add('no-scroll');
    }
    
  }

  get expanded () {
    return this.getAttribute('aria-expanded') === 'true';
  }

  get controlledElement() {
    const element = document.getElementById(this.getAttribute('aria-controls'));
    return element;
  }
  get controlledElementOverlay() {
      const element = document.getElementById(this.getAttribute('aria-controls')+'__overlay');
      return element;
  }
}
try {
  window.customElements.define('call-popin', callPopin, { extends: "button" });
  window.customElements.define('call-popin-span', callPopinSpan, { extends: "span" });
} catch(e) {}